const header = {
  el: {
    root: document.querySelector<HTMLElement>('.header'),
    html: document.querySelector<HTMLElement>('html'),
    body: document.querySelector<HTMLElement>('.body'),
    main: document.querySelector<HTMLElement>('.main'),
    footer: document.querySelector<HTMLElement>('.footer'),
    hamburger: document.querySelector<HTMLElement>('.hamburger'),
    header: document.querySelectorAll<HTMLElement>('.header'),
    headerLogo: document.querySelector<HTMLElement>('.header__logo'),
    button: document.querySelector<HTMLElement>('.header-button'),
    trigger: document.querySelector<HTMLButtonElement>('.header__trigger'),
    mobileMenu: document.querySelector<HTMLDivElement>('.mobile-menu'),
    mobilenav: {
      root: document.querySelector<HTMLElement>('.mobile-nav'),
      items: document.querySelectorAll<HTMLElement>('.mobile-nav__item'),
      links: document.querySelectorAll<HTMLElement>('.mobile-nav__link'),
      switchers: document.querySelectorAll<HTMLButtonElement>('.mobile-nav__link-icon'),
    },
  },

  lastWindowHeight: 0,

  init(): void {
    if (!this.el.mobileMenu || !this.el.trigger) return

    if (this.el.mobilenav.root && this.el.hamburger) {
      this.el.hamburger.addEventListener('click', () => {
        this.handleHamburger()
      })
    }

    this.el.trigger.addEventListener('click', () => {
      header.toggleMobileMenu()
    })

    window.addEventListener('resize', () => this.closeMenuOnResize())
    window.addEventListener('scroll', () => this.handleScroll())
  },

  openMenu(): void {
    this.el.mobileMenu.classList.add('mobile-menu--open')
    this.el.trigger.classList.add('burger-menu--open')
    this.el.html.classList.add('u-disable-mobile-scroll')
  },

  closeMenu(): void {
    this.el.mobileMenu.classList.remove('mobile-menu--open')
    this.el.trigger.classList.remove('burger-menu--open')
    // document.body.classList.remove("u-disable-mobile-scroll");
    this.el.html.classList.remove('u-disable-mobile-scroll')
    // header.toggleCookieButton({ display: "flex" });
  },

  closeMenuOnResize(): void {
    const currentHeight = window.innerHeight
    const verticalResize = currentHeight !== this.lastWindowHeight
    const isMenuOpened = this.el.mobileMenu.classList.contains('mobile-menu--open')
    this.lastWindowHeight = currentHeight

    if (!verticalResize && isMenuOpened) this.closeMenu()
  },

  toggleMobileMenu(): void {
    if (this.el.trigger.classList.contains('burger-menu--open')) {
      header.closeMenu()
      return
    }
    header.openMenu()
  },

  handleScroll(): void {
    if (window.scrollY >= 5) {
      this.el.body.classList.add('body--scrolled')
      this.el.button.classList.add('square')
    } else {
      this.el.body.classList.remove('body--scrolled')
      this.el.button.classList.remove('square')
    }
  },

  handleHamburger(): void {
    if (!this.el.body.classList.contains('mobile-nav-open')) {
      this.el.body.classList.add('mobile-nav-open')
    } else {
      this.el.body.classList.remove('mobile-nav-open')
    }
  },
}

export default header
